import { MessageBox, type MessageBoxConfirmOptions } from "zhihao-ui-react";
import type { ReactNode } from "react";

/** 管理后台二次确认统一复用 UI Kit 弹框，避免 Ant、原生 confirm 与 MessageBox 的外观分裂。 */
export const confirmDialog = async (
    message: ReactNode,
    title: ReactNode = "提示",
    options: MessageBoxConfirmOptions = {}
): Promise<boolean> => {
    try {
        await MessageBox.confirm(message, title, {
            ...options,
            closeOnClickModal: false,
            showClose: true,
            cancelButtonText: options.cancelButtonText ?? "取消",
            confirmButtonText: options.confirmButtonText ?? "确认"
        });
        return true;
    } catch (reason) {
        if (reason === "cancel" || (reason instanceof Error && reason.message === "cancel")) return false;
        throw reason;
    }
};
